import React from 'react';
import { format } from 'date-fns';
import { CalendarPlusIcon, SunIcon } from 'lucide-react';
import { useSelfService } from '../../hooks/useSelfService';
import { formatDays } from '../../utils/format';
import { trimNumber } from '../../utils/selfService';
import { Button } from '../ui/Button';
export function PtoBalanceCard({
  onRequest
}: {
  onRequest: () => void;
}) {
  const {
    policy,
    balance,
    available,
    pendingDays,
    scheduledDays,
    usedThisYear,
    nextAccrual
  } = useSelfService();
  const stats = [{
    label: 'Used this year',
    value: formatDays(usedThisYear)
  }, {
    label: 'Scheduled',
    value: formatDays(scheduledDays)
  }, {
    label: 'Pending',
    value: formatDays(pendingDays)
  }, {
    label: 'Accrues next',
    value: format(nextAccrual, 'MMM d, yyyy')
  }];
  return <section className="relative overflow-hidden rounded-2xl bg-navy p-6 text-white shadow-lift md:p-8" aria-label="PTO balance" data-id="element-776" data-mp="23xkxv2bil6v">
      <span className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-white/[0.04]" aria-hidden="true" data-id="element-777" data-mp="3tbjhz4uj7per" />
      <span className="pointer-events-none absolute -bottom-24 right-24 h-48 w-48 rounded-full bg-azure/10" aria-hidden="true" data-id="element-778" data-mp="1z8borazoi1sm" />

      <div className="relative flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-779" data-mp="294ol6gmlytr2">
        <div data-id="element-780" data-mp="2e3rp1xquqtxg">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium ring-1 ring-inset ring-white/15" data-id="element-781" data-mp="2e4avoib1xvw6">
            <SunIcon className="h-3.5 w-3.5 text-flame" aria-hidden="true" data-id="element-782" data-mp="2i5363evnu6u1" />
            {policy?.name ?? 'No policy assigned'}
          </span>
          <p className="mt-5 flex items-baseline gap-2" data-id="element-783" data-mp="2rvg1k250jkey">
            <span className="text-6xl font-semibold tracking-tight" data-id="element-784" data-mp="2rvy2hc2memt7">{trimNumber(balance)}</span>
            <span className="text-xl font-medium text-white/70" data-id="element-785" data-mp="2wthhie7573m7">days</span>
          </p>
          <p className="mt-1 text-sm text-white/70" data-id="element-786" data-mp="31ux2y7d8fc54">Available balance</p>
          <p className="mt-3 text-xs text-white/60" data-id="element-787" data-mp="35u5z1ivqvm3u">
            <span className="font-semibold text-white" data-id="element-788" data-mp="35sl25mlyjr2t">{trimNumber(available)} days</span> free to request after scheduled and pending time
          </p>
        </div>
        <Button variant="primary" icon={CalendarPlusIcon} onClick={onRequest} className="h-12 rounded-2xl px-6 text-[15px]" data-id="element-789" data-mp="11sdyojy7ygao">
          Request Time Off
        </Button>
      </div>

      <dl className="relative mt-8 grid grid-cols-2 gap-4 border-t border-white/10 pt-5 md:grid-cols-4" data-id="element-790" data-mp="1arj1w3kq6xt6">
        {stats.map(s => <div key={s.label} data-id="element-791" data-mp="1peubw119e9r6">
            <dt className="text-[11px] font-medium uppercase tracking-wider text-white/50" data-id="element-792" data-mp="1khkkwgy81q18">{s.label}</dt>
            <dd className="mt-1 text-base font-semibold" data-id="element-793" data-mp="1yh3hqdll1ey8">{s.value}</dd>
          </div>)}
      </dl>
    </section>;
}